
Object.defineProperty(exports, "__esModule", { value: true });

const {
  Decimal,
  objectEnumValues,
  makeStrictEnum,
  Public,
  getRuntime,
  skip
} = require('@prisma/client/runtime/index-browser.js')


const Prisma = {}

exports.Prisma = Prisma
exports.$Enums = {}

/**
 * Prisma Client JS version: 6.5.0
 * Query Engine version: 173f8d54f8d52e692c7e27e72a88314ec7aeff60
 */
Prisma.prismaVersion = {
  client: "6.5.0",
  engine: "173f8d54f8d52e692c7e27e72a88314ec7aeff60"
}

Prisma.PrismaClientKnownRequestError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientKnownRequestError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)};
Prisma.PrismaClientUnknownRequestError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientUnknownRequestError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientRustPanicError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientRustPanicError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientInitializationError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientInitializationError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientValidationError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientValidationError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.Decimal = Decimal

/**
 * Re-export of sql-template-tag
 */
Prisma.sql = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`sqltag is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.empty = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`empty is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.join = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`join is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.raw = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`raw is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.validator = Public.validator

/**
* Extensions
*/
Prisma.getExtensionContext = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`Extensions.getExtensionContext is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.defineExtension = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`Extensions.defineExtension is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}

/**
 * Shorthand utilities for JSON filtering
 */
Prisma.DbNull = objectEnumValues.instances.DbNull
Prisma.JsonNull = objectEnumValues.instances.JsonNull
Prisma.AnyNull = objectEnumValues.instances.AnyNull

Prisma.NullTypes = {
  DbNull: objectEnumValues.classes.DbNull,
  JsonNull: objectEnumValues.classes.JsonNull,
  AnyNull: objectEnumValues.classes.AnyNull
}



/**
 * Enums
 */

exports.Prisma.TransactionIsolationLevel = makeStrictEnum({
  ReadUncommitted: 'ReadUncommitted',
  ReadCommitted: 'ReadCommitted',
  RepeatableRead: 'RepeatableRead',
  Serializable: 'Serializable'
});

exports.Prisma.CandidateScalarFieldEnum = {
  id: 'id',
  firstName: 'firstName',
  lastName: 'lastName',
  email: 'email',
  phone: 'phone',
  nationality: 'nationality',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  summary: 'summary'
};

exports.Prisma.CandidateJobProspectScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  candidateId: 'candidateId',
  teamId: 'teamId',
  channel: 'channel',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt'
};

exports.Prisma.CandidateJobScalarFieldEnum = {
  candidateId: 'candidateId',
  jobId: 'jobId',
  joinedAt: 'joinedAt',
  deletedAt: 'deletedAt',
  candidateStatus: 'candidateStatus'
};

exports.Prisma.CandidateUsersScalarFieldEnum = {
  candidateId: 'candidateId',
  userId: 'userId',
  joinedAt: 'joinedAt'
};

exports.Prisma.CandidateFileScalarFieldEnum = {
  id: 'id',
  candidateId: 'candidateId',
  quizId: 'quizId',
  fileType: 'fileType',
  fileUrl: 'fileUrl',
  uploadedAt: 'uploadedAt',
  fileMetadata: 'fileMetadata'
};

exports.Prisma.CandidateProctoringReportScalarFieldEnum = {
  id: 'id',
  candidateId: 'candidateId',
  jobId: 'jobId',
  observation: 'observation',
  evidence: 'evidence',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt'
};

exports.Prisma.CandidateJobScreeningScalarFieldEnum = {
  id: 'id',
  candidateId: 'candidateId',
  jobId: 'jobId',
  detailsId: 'detailsId',
  detailsValue: 'detailsValue',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt'
};

exports.Prisma.CandidateJobApplicationScalarFieldEnum = {
  id: 'id',
  candidateId: 'candidateId',
  jobId: 'jobId',
  settingsId: 'settingsId',
  settingsValue: 'settingsValue',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt'
};

exports.Prisma.CandidateJobScreeningApplicationScalarFieldEnum = {
  id: 'id',
  candidateId: 'candidateId',
  jobId: 'jobId',
  settingsId: 'settingsId',
  settingsValue: 'settingsValue',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt'
};

exports.Prisma.CandidateQuizDetailReportScalarFieldEnum = {
  id: 'id',
  candidateId: 'candidateId',
  jobId: 'jobId',
  quizId: 'quizId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt'
};

exports.Prisma.CandidateQuizReportScalarFieldEnum = {
  id: 'id',
  candidateId: 'candidateId',
  jobId: 'jobId',
  jdMatch: 'jdMatch',
  rating: 'rating',
  quizScore: 'quizScore',
  videoResume: 'videoResume',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt'
};

exports.Prisma.CandidateRatingsReportScalarFieldEnum = {
  id: 'id',
  commentedBy: 'commentedBy',
  candidateId: 'candidateId',
  jobId: 'jobId',
  comments: 'comments',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt'
};

exports.Prisma.CandidateSkillReportScalarFieldEnum = {
  id: 'id',
  candidateId: 'candidateId',
  jobId: 'jobId',
  quizId: 'quizId',
  jdMatch: 'jdMatch',
  jobSkillId: 'jobSkillId',
  feedback: 'feedback',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt'
};

exports.Prisma.CandidateTaxonomyReportScalarFieldEnum = {
  id: 'id',
  candidateId: 'candidateId',
  jobId: 'jobId',
  quizId: 'quizId',
  taxonomy: 'taxonomy',
  feedback: 'feedback',
  score: 'score',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.CandidateContactDetailScalarFieldEnum = {
  id: 'id',
  candidateId: 'candidateId',
  addressLine1: 'addressLine1',
  addressLine2: 'addressLine2',
  city: 'city',
  state: 'state',
  postalCode: 'postalCode',
  country: 'country',
  website: 'website',
  linkedinUrl: 'linkedinUrl'
};

exports.Prisma.CandidateEducationScalarFieldEnum = {
  id: 'id',
  candidateId: 'candidateId',
  institution: 'institution',
  degree: 'degree',
  field: 'field',
  startDate: 'startDate',
  endDate: 'endDate',
  description: 'description',
  location: 'location'
};

exports.Prisma.CandidateWorkExperienceScalarFieldEnum = {
  id: 'id',
  candidateId: 'candidateId',
  title: 'title',
  company: 'company',
  startDate: 'startDate',
  endDate: 'endDate',
  description: 'description',
  location: 'location'
};

exports.Prisma.CandidateInternshipScalarFieldEnum = {
  id: 'id',
  candidateId: 'candidateId',
  title: 'title',
  company: 'company',
  startDate: 'startDate',
  endDate: 'endDate',
  description: 'description',
  location: 'location'
};

exports.Prisma.CandidateSocialCauseScalarFieldEnum = {
  id: 'id',
  candidateId: 'candidateId',
  title: 'title',
  organization: 'organization',
  causeArea: 'causeArea',
  description: 'description',
  startDate: 'startDate',
  endDate: 'endDate',
  location: 'location'
};

exports.Prisma.CandidateProjectScalarFieldEnum = {
  id: 'id',
  candidateId: 'candidateId',
  title: 'title',
  description: 'description',
  url: 'url',
  startDate: 'startDate',
  endDate: 'endDate'
};

exports.Prisma.CandidateCertificationScalarFieldEnum = {
  id: 'id',
  candidateId: 'candidateId',
  name: 'name',
  issuingOrg: 'issuingOrg',
  issueDate: 'issueDate',
  expirationDate: 'expirationDate',
  credentialId: 'credentialId',
  credentialUrl: 'credentialUrl'
};

exports.Prisma.CandidateSkillScalarFieldEnum = {
  id: 'id',
  candidateId: 'candidateId',
  name: 'name',
  proficiency: 'proficiency'
};

exports.Prisma.CandidateCommunicationScalarFieldEnum = {
  id: 'id',
  candidateId: 'candidateId',
  verbalCommunication: 'verbalCommunication',
  writtenCommunication: 'writtenCommunication',
  interpersonalSkills: 'interpersonalSkills',
  additionalNotes: 'additionalNotes'
};

exports.Prisma.CandidateLanguageScalarFieldEnum = {
  id: 'id',
  candidateId: 'candidateId',
  languageName: 'languageName',
  reading: 'reading',
  writing: 'writing',
  listening: 'listening',
  speaking: 'speaking'
};

exports.Prisma.CandidateNationalIdentifierScalarFieldEnum = {
  id: 'id',
  candidateId: 'candidateId',
  identifierNumber: 'identifierNumber',
  country: 'country',
  issueDate: 'issueDate',
  expiryDate: 'expiryDate',
  description: 'description',
  type: 'type'
};

exports.Prisma.CandidateCandidateReferenceScalarFieldEnum = {
  id: 'id',
  candidateId: 'candidateId',
  name: 'name',
  relationship: 'relationship',
  email: 'email',
  phone: 'phone'
};

exports.Prisma.CandidateOnlineProfileScalarFieldEnum = {
  id: 'id',
  candidateId: 'candidateId',
  profileUrl: 'profileUrl',
  scrapedData: 'scrapedData',
  scrapedAt: 'scrapedAt',
  platform: 'platform'
};

exports.Prisma.CandidateProductivityDataScalarFieldEnum = {
  id: 'id',
  candidateId: 'candidateId',
  data: 'data',
  scrapedAt: 'scrapedAt',
  tool: 'tool'
};

exports.Prisma.DashboardScalarFieldEnum = {
  id: 'id',
  linkId: 'linkId',
  teamId: 'teamId',
  userId: 'userId',
  doIndex: 'doIndex',
  password: 'password',
  showConversions: 'showConversions',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.DepartmentScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  name: 'name',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  teamId: 'teamId'
};

exports.Prisma.EmailScalarFieldEnum = {
  id: 'id',
  jobId: 'jobId',
  teamId: 'teamId',
  from: 'from',
  subject: 'subject',
  to: 'to',
  sentAt: 'sentAt',
  updatedAt: 'updatedAt',
  status: 'status'
};

exports.Prisma.SentEmailScalarFieldEnum = {
  id: 'id',
  type: 'type',
  createdAt: 'createdAt',
  teamId: 'teamId'
};

exports.Prisma.EmailBlacklistScalarFieldEnum = {
  id: 'id'
};

exports.Prisma.CollaboratorAccessEnumScalarFieldEnum = {
  value: 'value'
};

exports.Prisma.CollaboratorRolesEnumScalarFieldEnum = {
  value: 'value'
};

exports.Prisma.DetailValueTypeEnumScalarFieldEnum = {
  value: 'value'
};

exports.Prisma.EmailStatusEnumScalarFieldEnum = {
  value: 'value'
};

exports.Prisma.JobPriorityEnumScalarFieldEnum = {
  value: 'value'
};

exports.Prisma.JobStatusEnumScalarFieldEnum = {
  value: 'value'
};

exports.Prisma.JobSkillTypeEnumScalarFieldEnum = {
  value: 'value'
};

exports.Prisma.QuestionTypeEnumScalarFieldEnum = {
  value: 'value'
};

exports.Prisma.TemplateTypeEnumScalarFieldEnum = {
  value: 'value'
};

exports.Prisma.CandidateStatusEnumScalarFieldEnum = {
  value: 'value'
};

exports.Prisma.WebhookReceiverEnumScalarFieldEnum = {
  value: 'value'
};

exports.Prisma.FolderTypeEnumScalarFieldEnum = {
  value: 'value'
};

exports.Prisma.FolderAccessLevelEnumScalarFieldEnum = {
  value: 'value'
};

exports.Prisma.FolderUserRoleEnumScalarFieldEnum = {
  value: 'value'
};

exports.Prisma.ProfessionalPlatformEnumScalarFieldEnum = {
  value: 'value'
};

exports.Prisma.ProductivityToolEnumScalarFieldEnum = {
  value: 'value'
};

exports.Prisma.LanguageProficiencyEnumScalarFieldEnum = {
  value: 'value'
};

exports.Prisma.NationalIdentifierEnumScalarFieldEnum = {
  value: 'value'
};

exports.Prisma.QuizStatusEnumScalarFieldEnum = {
  value: 'value'
};

exports.Prisma.TaxonomyTagsEnumScalarFieldEnum = {
  value: 'value'
};

exports.Prisma.FolderScalarFieldEnum = {
  id: 'id',
  name: 'name',
  teamId: 'teamId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  type: 'type',
  accessLevel: 'accessLevel'
};

exports.Prisma.FolderUserScalarFieldEnum = {
  id: 'id',
  folderId: 'folderId',
  userId: 'userId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  role: 'role'
};

exports.Prisma.FolderAccessRequestScalarFieldEnum = {
  id: 'id',
  folderId: 'folderId',
  userId: 'userId',
  createdAt: 'createdAt'
};

exports.Prisma.CandidateGithubAnalysisScalarFieldEnum = {
  id: 'id',
  candidateId: 'candidateId',
  githubUrl: 'githubUrl',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  username: 'username',
  userSince: 'userSince',
  avatarUrl: 'avatarUrl',
  bio: 'bio',
  location: 'location',
  company: 'company',
  blog: 'blog',
  publicRepos: 'publicRepos',
  followers: 'followers',
  following: 'following',
  technicalSkills: 'technicalSkills',
  topLanguages: 'topLanguages',
  contributionActivity: 'contributionActivity',
  qualitativeAssessment: 'qualitativeAssessment',
  repositoryCount: 'repositoryCount',
  ownedRepositories: 'ownedRepositories',
  forkedRepositories: 'forkedRepositories',
  starredRepositoryCount: 'starredRepositoryCount',
  codeQualityScore: 'codeQualityScore',
  testCoverageAverage: 'testCoverageAverage',
  documentationQuality: 'documentationQuality',
  overallScore: 'overallScore',
  strengthAreas: 'strengthAreas',
  improvementAreas: 'improvementAreas',
  topRepositories: 'topRepositories'
};

exports.Prisma.CandidateGithubRepositoryScalarFieldEnum = {
  id: 'id',
  analysisId: 'analysisId',
  name: 'name',
  fullName: 'fullName',
  description: 'description',
  isPrivate: 'isPrivate',
  isArchived: 'isArchived',
  isFork: 'isFork',
  url: 'url',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  pushedAt: 'pushedAt',
  language: 'language',
  size: 'size',
  stargazersCount: 'stargazersCount',
  watchersCount: 'watchersCount',
  forksCount: 'forksCount',
  openIssuesCount: 'openIssuesCount',
  topics: 'topics',
  linesOfCode: 'linesOfCode',
  codeQuality: 'codeQuality',
  hasTests: 'hasTests',
  testCoverage: 'testCoverage',
  hasDocumentation: 'hasDocumentation',
  ownerContributions: 'ownerContributions',
  contributorsCount: 'contributorsCount'
};

exports.Prisma.IntegrationScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  name: 'name',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  teamId: 'teamId',
  slug: 'slug',
  description: 'description',
  readme: 'readme',
  developer: 'developer',
  website: 'website',
  logo: 'logo',
  screenshots: 'screenshots',
  verified: 'verified',
  installUrl: 'installUrl',
  guideUrl: 'guideUrl',
  comingSoon: 'comingSoon',
  category: 'category'
};

exports.Prisma.InstalledIntegrationScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  integrationId: 'integrationId',
  teamId: 'teamId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  credentials: 'credentials'
};

exports.Prisma.JobAdditionalDetailsScalarFieldEnum = {
  id: 'id',
  jobId: 'jobId',
  detailKey: 'detailKey',
  detailValueType: 'detailValueType',
  detailValueOptions: 'detailValueOptions',
  isRequired: 'isRequired',
  isBuiltin: 'isBuiltin',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt'
};

exports.Prisma.JobCollaboratorsScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  jobId: 'jobId',
  role: 'role',
  access: 'access',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt'
};

exports.Prisma.JobSettingsScalarFieldEnum = {
  id: 'id',
  jobId: 'jobId',
  settingsKey: 'settingsKey',
  settingsValue: 'settingsValue',
  isRequired: 'isRequired',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt'
};

exports.Prisma.JobSkillsScalarFieldEnum = {
  id: 'id',
  jobId: 'jobId',
  skillName: 'skillName',
  subSkills: 'subSkills',
  skillType: 'skillType',
  skillWeightage: 'skillWeightage',
  taxonomyWeightage: 'taxonomyWeightage',
  priority: 'priority',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt'
};

exports.Prisma.JobScalarFieldEnum = {
  id: 'id',
  title: 'title',
  key: 'key',
  url: 'url',
  comments: 'comments',
  archived: 'archived',
  description: 'description',
  priority: 'priority',
  experienceStart: 'experienceStart',
  experienceEnd: 'experienceEnd',
  positions: 'positions',
  descriptionPath: 'descriptionPath',
  campaignStart: 'campaignStart',
  campaignEnd: 'campaignEnd',
  userId: 'userId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  externalId: 'externalId',
  tenantId: 'tenantId',
  departmentId: 'departmentId',
  teamId: 'teamId',
  status: 'status',
  folderId: 'folderId'
};

exports.Prisma.JobLinksScalarFieldEnum = {
  jobId: 'jobId',
  linkId: 'linkId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt'
};

exports.Prisma.JobWebhookScalarFieldEnum = {
  jobId: 'jobId',
  webhookId: 'webhookId'
};

exports.Prisma.LinkScalarFieldEnum = {
  id: 'id',
  domain: 'domain',
  key: 'key',
  url: 'url',
  shortLink: 'shortLink',
  archived: 'archived',
  expiresAt: 'expiresAt',
  expiredUrl: 'expiredUrl',
  password: 'password',
  trackConversion: 'trackConversion',
  proxy: 'proxy',
  title: 'title',
  description: 'description',
  image: 'image',
  video: 'video',
  utmSource: 'utmSource',
  utmMedium: 'utmMedium',
  utmCampaign: 'utmCampaign',
  utmTerm: 'utmTerm',
  utmContent: 'utmContent',
  rewrite: 'rewrite',
  doIndex: 'doIndex',
  ios: 'ios',
  android: 'android',
  geo: 'geo',
  userId: 'userId',
  teamId: 'teamId',
  programId: 'programId',
  folderId: 'folderId',
  externalId: 'externalId',
  tenantId: 'tenantId',
  publicStats: 'publicStats',
  clicks: 'clicks',
  lastClicked: 'lastClicked',
  leads: 'leads',
  sales: 'sales',
  saleAmount: 'saleAmount',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  testVariants: 'testVariants',
  testStartedAt: 'testStartedAt',
  testCompletedAt: 'testCompletedAt',
  comments: 'comments',
  partnerId: 'partnerId'
};

exports.Prisma.OAuthAppScalarFieldEnum = {
  id: 'id',
  integrationId: 'integrationId',
  clientId: 'clientId',
  hashedClientSecret: 'hashedClientSecret',
  partialClientSecret: 'partialClientSecret',
  redirectUris: 'redirectUris',
  pkce: 'pkce'
};

exports.Prisma.OAuthCodeScalarFieldEnum = {
  id: 'id',
  clientId: 'clientId',
  userId: 'userId',
  teamId: 'teamId',
  code: 'code',
  scopes: 'scopes',
  redirectUri: 'redirectUri',
  codeChallenge: 'codeChallenge',
  codeChallengeMethod: 'codeChallengeMethod',
  expiresAt: 'expiresAt',
  createdAt: 'createdAt'
};

exports.Prisma.OAuthRefreshTokenScalarFieldEnum = {
  id: 'id',
  installationId: 'installationId',
  accessTokenId: 'accessTokenId',
  hashedRefreshToken: 'hashedRefreshToken',
  expiresAt: 'expiresAt',
  createdAt: 'createdAt'
};

exports.Prisma.QuizLibraryScalarFieldEnum = {
  id: 'id',
  skillName: 'skillName',
  skillLevel: 'skillLevel',
  question: 'question',
  taxonomyTags: 'taxonomyTags',
  asset: 'asset',
  skillTagsA: 'skillTagsA',
  skillTagsB: 'skillTagsB',
  skillTagsC: 'skillTagsC',
  skillTagsD: 'skillTagsD',
  choiceA: 'choiceA',
  choiceB: 'choiceB',
  choiceC: 'choiceC',
  choiceD: 'choiceD',
  relevanceA: 'relevanceA',
  relevanceB: 'relevanceB',
  relevanceC: 'relevanceC',
  relevanceD: 'relevanceD',
  scoreA: 'scoreA',
  scoreB: 'scoreB',
  scoreC: 'scoreC',
  scoreD: 'scoreD',
  experienceLevel: 'experienceLevel',
  experienceAMin: 'experienceAMin',
  experienceAMax: 'experienceAMax',
  experienceBMin: 'experienceBMin',
  experienceBMax: 'experienceBMax',
  experienceCMin: 'experienceCMin',
  experienceCMax: 'experienceCMax',
  experienceDMin: 'experienceDMin',
  experienceDMax: 'experienceDMax',
  difficultyLevel: 'difficultyLevel',
  readingTimeSeconds: 'readingTimeSeconds',
  version: 'version',
  gpt: 'gpt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt'
};

exports.Prisma.JobQuizLibraryMappingScalarFieldEnum = {
  id: 'id',
  libraryId: 'libraryId',
  jobId: 'jobId',
  usage: 'usage',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt'
};

exports.Prisma.QuizLibraryUsageScalarFieldEnum = {
  id: 'id',
  libraryId: 'libraryId',
  usage: 'usage',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt'
};

exports.Prisma.CandidateQuizScalarFieldEnum = {
  id: 'id',
  candidateId: 'candidateId',
  quizId: 'quizId',
  status: 'status',
  startedAt: 'startedAt',
  completedAt: 'completedAt',
  currentQuestion: 'currentQuestion',
  score: 'score',
  metadata: 'metadata'
};

exports.Prisma.CandidateQuestionScalarFieldEnum = {
  id: 'id',
  questionId: 'questionId',
  questionNumber: 'questionNumber',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  type: 'type'
};

exports.Prisma.QuestionMcqOptionScalarFieldEnum = {
  id: 'id',
  text: 'text',
  isCorrect: 'isCorrect',
  questionId: 'questionId',
  order: 'order'
};

exports.Prisma.QuestionRankOptionScalarFieldEnum = {
  id: 'id',
  text: 'text',
  correctRank: 'correctRank',
  questionId: 'questionId',
  order: 'order',
  createdAt: 'createdAt'
};

exports.Prisma.QuestionMcqAnswerScalarFieldEnum = {
  id: 'id',
  quizId: 'quizId',
  questionId: 'questionId',
  optionId: 'optionId',
  timeSpent: 'timeSpent',
  score: 'score',
  createdAt: 'createdAt'
};

exports.Prisma.QuestionRankAnswerScalarFieldEnum = {
  id: 'id',
  quizId: 'quizId',
  questionId: 'questionId',
  timeSpent: 'timeSpent',
  score: 'score',
  createdAt: 'createdAt'
};

exports.Prisma.QuestionRankOptionAnswerScalarFieldEnum = {
  id: 'id',
  answerId: 'answerId',
  optionId: 'optionId',
  givenRank: 'givenRank'
};

exports.Prisma.TagScalarFieldEnum = {
  id: 'id',
  name: 'name',
  color: 'color',
  deletedAt: 'deletedAt',
  teamId: 'teamId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.JobTagScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  jobId: 'jobId',
  tagId: 'tagId'
};

exports.Prisma.LinkTagScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  linkId: 'linkId',
  tagId: 'tagId'
};

exports.Prisma.ContentTemplatesScalarFieldEnum = {
  template: 'template',
  version: 'version',
  templateType: 'templateType',
  name: 'name',
  teamId: 'teamId',
  userId: 'userId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.JobEmailTemplateScalarFieldEnum = {
  id: 'id',
  jobId: 'jobId',
  name: 'name',
  subject: 'subject',
  body: 'body',
  signature: 'signature',
  useSignature: 'useSignature',
  isDefault: 'isDefault',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  createdBy: 'createdBy'
};

exports.Prisma.CandidateEmailOutreachScalarFieldEnum = {
  id: 'id',
  emailTemplateId: 'emailTemplateId',
  candidateId: 'candidateId',
  jobId: 'jobId',
  userId: 'userId',
  resendId: 'resendId',
  messageId: 'messageId',
  status: 'status',
  subject: 'subject',
  body: 'body',
  sentAt: 'sentAt',
  openedAt: 'openedAt',
  clickedAt: 'clickedAt',
  deliveredAt: 'deliveredAt',
  complainedAt: 'complainedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.TokenScalarFieldEnum = {
  id: 'id',
  name: 'name',
  hashedKey: 'hashedKey',
  partialKey: 'partialKey',
  expires: 'expires',
  lastUsed: 'lastUsed',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  userId: 'userId'
};

exports.Prisma.ExtensionTokenScalarFieldEnum = {
  identifier: 'identifier',
  token: 'token',
  expires: 'expires',
  userId: 'userId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.RestrictedTokenScalarFieldEnum = {
  id: 'id',
  name: 'name',
  hashedKey: 'hashedKey',
  partialKey: 'partialKey',
  scopes: 'scopes',
  expires: 'expires',
  lastUsed: 'lastUsed',
  rateLimit: 'rateLimit',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  userId: 'userId',
  teamId: 'teamId',
  installationId: 'installationId'
};

exports.Prisma.VerificationTokenScalarFieldEnum = {
  identifier: 'identifier',
  token: 'token',
  expires: 'expires'
};

exports.Prisma.EmailVerificationTokenScalarFieldEnum = {
  identifier: 'identifier',
  token: 'token',
  expires: 'expires'
};

exports.Prisma.PasswordResetTokenScalarFieldEnum = {
  identifier: 'identifier',
  token: 'token',
  expires: 'expires'
};

exports.Prisma.UtmTemplateScalarFieldEnum = {
  id: 'id',
  name: 'name',
  utmSource: 'utmSource',
  utmMedium: 'utmMedium',
  utmCampaign: 'utmCampaign',
  utmTerm: 'utmTerm',
  utmContent: 'utmContent',
  ref: 'ref',
  userId: 'userId',
  teamId: 'teamId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.WebhookScalarFieldEnum = {
  id: 'id',
  receiver: 'receiver',
  installationId: 'installationId',
  teamId: 'teamId',
  name: 'name',
  url: 'url',
  secret: 'secret',
  triggers: 'triggers',
  consecutiveFailures: 'consecutiveFailures',
  lastFailedAt: 'lastFailedAt',
  disabledAt: 'disabledAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.LinkWebhookScalarFieldEnum = {
  linkId: 'linkId',
  webhookId: 'webhookId'
};

exports.Prisma.ProviderRequestsScalarFieldEnum = {
  id: 'id',
  options: 'options'
};

exports.Prisma.ProvidersScalarFieldEnum = {
  id: 'id'
};

exports.Prisma.RefreshTokenTypesScalarFieldEnum = {
  value: 'value',
  comment: 'comment'
};

exports.Prisma.RefreshTokenScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  expiresAt: 'expiresAt',
  userId: 'userId',
  metadata: 'metadata',
  type: 'type',
  refreshTokenHash: 'refreshTokenHash'
};

exports.Prisma.RoleScalarFieldEnum = {
  id: 'id'
};

exports.Prisma.SessionScalarFieldEnum = {
  id: 'id',
  sessionToken: 'sessionToken',
  userId: 'userId',
  expires: 'expires'
};

exports.Prisma.UserProvidersScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  userId: 'userId',
  accessToken: 'accessToken',
  refreshTokenKey: 'refreshTokenKey',
  providerId: 'providerId',
  providerUserId: 'providerUserId'
};

exports.Prisma.AuthUserRolesScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  userId: 'userId',
  role: 'role'
};

exports.Prisma.UserSecurityKeysScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  credentialId: 'credentialId',
  credentialPublicKey: 'credentialPublicKey',
  counter: 'counter',
  transports: 'transports',
  nickname: 'nickname'
};

exports.Prisma.AccountScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  lastSeen: 'lastSeen',
  disabled: 'disabled',
  displayName: 'displayName',
  image: 'image',
  locale: 'locale',
  email: 'email',
  phoneNumber: 'phoneNumber',
  passwordHash: 'passwordHash',
  emailVerified: 'emailVerified',
  phoneNumberVerified: 'phoneNumberVerified',
  newEmail: 'newEmail',
  otpMethodLastUsed: 'otpMethodLastUsed',
  otpHash: 'otpHash',
  otpHashExpiresAt: 'otpHashExpiresAt',
  defaultRole: 'defaultRole',
  isAnonymous: 'isAnonymous',
  totpSecret: 'totpSecret',
  activeMfaType: 'activeMfaType',
  ticket: 'ticket',
  ticketExpiresAt: 'ticketExpiresAt',
  metadata: 'metadata',
  webauthnCurrentChallenge: 'webauthnCurrentChallenge'
};

exports.Prisma.CommissionScalarFieldEnum = {
  id: 'id',
  programId: 'programId',
  partnerId: 'partnerId',
  linkId: 'linkId',
  payoutId: 'payoutId',
  invoiceId: 'invoiceId',
  customerId: 'customerId',
  eventId: 'eventId',
  amount: 'amount',
  quantity: 'quantity',
  earnings: 'earnings',
  currency: 'currency',
  status: 'status',
  type: 'type',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.CustomerScalarFieldEnum = {
  id: 'id',
  name: 'name',
  email: 'email',
  avatar: 'avatar',
  externalId: 'externalId',
  stripeCustomerId: 'stripeCustomerId',
  linkId: 'linkId',
  clickId: 'clickId',
  clickedAt: 'clickedAt',
  country: 'country',
  teamId: 'teamId',
  teamConnectId: 'teamConnectId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.DiscountScalarFieldEnum = {
  id: 'id',
  amount: 'amount',
  duration: 'duration',
  maxDuration: 'maxDuration',
  couponId: 'couponId',
  couponTestId: 'couponTestId',
  teamId: 'teamId',
  programId: 'programId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  type: 'type',
  interval: 'interval'
};

exports.Prisma.DomainScalarFieldEnum = {
  id: 'id',
  slug: 'slug',
  verified: 'verified',
  placeholder: 'placeholder',
  expiredUrl: 'expiredUrl',
  notFoundUrl: 'notFoundUrl',
  primary: 'primary',
  archived: 'archived',
  lastChecked: 'lastChecked',
  appleAppSiteAssociation: 'appleAppSiteAssociation',
  assetLinks: 'assetLinks',
  logo: 'logo',
  teamId: 'teamId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.RegisteredDomainScalarFieldEnum = {
  id: 'id',
  slug: 'slug',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  expiresAt: 'expiresAt',
  teamId: 'teamId',
  domainId: 'domainId'
};

exports.Prisma.DefaultDomainsScalarFieldEnum = {
  id: 'id',
  pandaqzlink: 'pandaqzlink',
  hirepandalink: 'hirepandalink',
  valleyhirepandacom: 'valleyhirepandacom',
  apply2joblink: 'apply2joblink',
  applybetterlink: 'applybetterlink',
  click2worklink: 'click2worklink',
  fastapplylink: 'fastapplylink',
  hiredirectlink: 'hiredirectlink',
  instaapplylink: 'instaapplylink',
  takeqzlink: 'takeqzlink',
  apply2work: 'apply2work',
  pandaquizme: 'pandaquizme',
  pandatestme: 'pandatestme',
  pandaquizin: 'pandaquizin',
  pandatestapp: 'pandatestapp',
  pandatestin: 'pandatestin',
  applyherework: 'applyherework',
  apply2jobcom: 'apply2jobcom',
  teamId: 'teamId'
};

exports.Prisma.SubscriptionStatusEnumScalarFieldEnum = {
  value: 'value'
};

exports.Prisma.WorkspacePlansEnumScalarFieldEnum = {
  value: 'value'
};

exports.Prisma.PricingPlanIntervalEnumScalarFieldEnum = {
  value: 'value'
};

exports.Prisma.PricingTypeEnumScalarFieldEnum = {
  value: 'value'
};

exports.Prisma.UserRolesEnumScalarFieldEnum = {
  value: 'value'
};

exports.Prisma.PayoutStatusEnumScalarFieldEnum = {
  value: 'value'
};

exports.Prisma.PayoutTypeEnumScalarFieldEnum = {
  value: 'value'
};

exports.Prisma.ProgramTypeEnumScalarFieldEnum = {
  value: 'value'
};

exports.Prisma.CommissionTypeEnumScalarFieldEnum = {
  value: 'value'
};

exports.Prisma.ProgramEnrollmentStatusEnumScalarFieldEnum = {
  value: 'value'
};

exports.Prisma.CommissionIntervalEnumScalarFieldEnum = {
  value: 'value'
};

exports.Prisma.PartnerStatusEnumScalarFieldEnum = {
  value: 'value'
};

exports.Prisma.PartnerRoleEnumScalarFieldEnum = {
  value: 'value'
};

exports.Prisma.InvoiceStatusEnumScalarFieldEnum = {
  value: 'value'
};

exports.Prisma.CommissionStatusEnumScalarFieldEnum = {
  value: 'value'
};

exports.Prisma.EventTypeEnumScalarFieldEnum = {
  value: 'value'
};

exports.Prisma.PaymentProviderEnumScalarFieldEnum = {
  value: 'value'
};

exports.Prisma.PartnerProfileTypeEnumScalarFieldEnum = {
  value: 'value'
};

exports.Prisma.PayoutInvoiceScalarFieldEnum = {
  id: 'id',
  teamId: 'teamId',
  number: 'number',
  programId: 'programId',
  status: 'status',
  amount: 'amount',
  fee: 'fee',
  total: 'total',
  receiptUrl: 'receiptUrl',
  createdAt: 'createdAt'
};

exports.Prisma.SubscriptionInvoiceScalarFieldEnum = {
  id: 'id',
  teamId: 'teamId',
  number: 'number',
  subscriptionId: 'subscriptionId',
  status: 'status',
  amount: 'amount',
  fee: 'fee',
  total: 'total',
  receiptUrl: 'receiptUrl',
  createdAt: 'createdAt',
  providerType: 'providerType',
  providerInvoiceId: 'providerInvoiceId',
  currency: 'currency',
  metadata: 'metadata'
};

exports.Prisma.JacksonIndexScalarFieldEnum = {
  id: 'id',
  key: 'key',
  storeKey: 'storeKey'
};

exports.Prisma.JacksonStoreScalarFieldEnum = {
  key: 'key',
  value: 'value',
  iv: 'iv',
  tag: 'tag',
  namespace: 'namespace',
  createdAt: 'createdAt',
  modifiedAt: 'modifiedAt'
};

exports.Prisma.JacksonTtlScalarFieldEnum = {
  key: 'key',
  expiresAt: 'expiresAt'
};

exports.Prisma.PartnerScalarFieldEnum = {
  id: 'id',
  name: 'name',
  companyName: 'companyName',
  profileType: 'profileType',
  email: 'email',
  image: 'image',
  description: 'description',
  country: 'country',
  status: 'status',
  stripeConnectId: 'stripeConnectId',
  payoutsEnabled: 'payoutsEnabled',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  showOnLeaderboard: 'showOnLeaderboard',
  payoutsEnabledAt: 'payoutsEnabledAt',
  website: 'website',
  websiteTxtRecord: 'websiteTxtRecord',
  websiteVerifiedAt: 'websiteVerifiedAt',
  youtube: 'youtube',
  youtubeVerifiedAt: 'youtubeVerifiedAt',
  twitter: 'twitter',
  twitterVerifiedAt: 'twitterVerifiedAt',
  linkedin: 'linkedin',
  linkedinVerifiedAt: 'linkedinVerifiedAt',
  instagram: 'instagram',
  instagramVerifiedAt: 'instagramVerifiedAt'
};

exports.Prisma.PartnerUserScalarFieldEnum = {
  id: 'id',
  role: 'role',
  userId: 'userId',
  partnerId: 'partnerId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.PartnerInviteScalarFieldEnum = {
  email: 'email',
  expires: 'expires',
  partnerId: 'partnerId',
  role: 'role',
  createdAt: 'createdAt'
};

exports.Prisma.PayoutScalarFieldEnum = {
  id: 'id',
  programId: 'programId',
  partnerId: 'partnerId',
  invoiceId: 'invoiceId',
  amount: 'amount',
  currency: 'currency',
  status: 'status',
  type: 'type',
  description: 'description',
  periodStart: 'periodStart',
  periodEnd: 'periodEnd',
  quantity: 'quantity',
  stripeTransferId: 'stripeTransferId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  paidAt: 'paidAt'
};

exports.Prisma.PriceScalarFieldEnum = {
  id: 'id',
  productId: 'productId',
  active: 'active',
  description: 'description',
  unitAmount: 'unitAmount',
  currency: 'currency',
  type: 'type',
  interval: 'interval',
  intervalCount: 'intervalCount',
  trialPeriodDays: 'trialPeriodDays',
  metadata: 'metadata',
  clicks: 'clicks',
  links: 'links',
  ai: 'ai',
  api: 'api',
  folders: 'folders',
  jobs: 'jobs',
  tags: 'tags',
  users: 'users',
  sales: 'sales',
  candidates: 'candidates'
};

exports.Prisma.ProductScalarFieldEnum = {
  id: 'id',
  active: 'active',
  name: 'name',
  description: 'description',
  image: 'image',
  metadata: 'metadata'
};

exports.Prisma.ProgramScalarFieldEnum = {
  id: 'id',
  teamId: 'teamId',
  name: 'name',
  slug: 'slug',
  logo: 'logo',
  wordmark: 'wordmark',
  brandColor: 'brandColor',
  domain: 'domain',
  url: 'url',
  type: 'type',
  cookieLength: 'cookieLength',
  defaultRewardId: 'defaultRewardId',
  defaultFolderId: 'defaultFolderId',
  defaultDiscountId: 'defaultDiscountId',
  holdingPeriodDays: 'holdingPeriodDays',
  minPayoutAmount: 'minPayoutAmount',
  landerData: 'landerData',
  resources: 'resources',
  termsUrl: 'termsUrl',
  ageVerification: 'ageVerification',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.ProgramEnrollmentScalarFieldEnum = {
  id: 'id',
  partnerId: 'partnerId',
  programId: 'programId',
  tenantId: 'tenantId',
  applicationId: 'applicationId',
  commissionAmount: 'commissionAmount',
  discountId: 'discountId',
  status: 'status',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.ProgramApplicationScalarFieldEnum = {
  id: 'id',
  programId: 'programId',
  partnerId: 'partnerId',
  name: 'name',
  email: 'email',
  proposal: 'proposal',
  website: 'website',
  comments: 'comments',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.RewardScalarFieldEnum = {
  id: 'id',
  programId: 'programId',
  name: 'name',
  event: 'event',
  type: 'type',
  amount: 'amount',
  maxDuration: 'maxDuration',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.PartnerRewardScalarFieldEnum = {
  id: 'id',
  programEnrollmentId: 'programEnrollmentId',
  rewardId: 'rewardId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.SubscriptionScalarFieldEnum = {
  id: 'id',
  status: 'status',
  metadata: 'metadata',
  priceId: 'priceId',
  quantity: 'quantity',
  cancelAtPeriodEnd: 'cancelAtPeriodEnd',
  created: 'created',
  currentPeriodStart: 'currentPeriodStart',
  currentPeriodEnd: 'currentPeriodEnd',
  endedAt: 'endedAt',
  cancelAt: 'cancelAt',
  cancelledAt: 'cancelledAt',
  trialStart: 'trialStart',
  trialEnd: 'trialEnd',
  providerType: 'providerType',
  providerSubscriptionId: 'providerSubscriptionId'
};

exports.Prisma.UserScalarFieldEnum = {
  id: 'id',
  email: 'email',
  isDeleted: 'isDeleted',
  isActive: 'isActive',
  isMachine: 'isMachine',
  defaultTeam: 'defaultTeam',
  defaultPartnerId: 'defaultPartnerId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  invalidLoginAttempts: 'invalidLoginAttempts',
  lockedAt: 'lockedAt',
  source: 'source',
  saasPartnerId: 'saasPartnerId',
  passwordHash: 'passwordHash',
  emailVerified: 'emailVerified',
  image: 'image',
  name: 'name',
  provider: 'provider',
  subscribed: 'subscribed'
};

exports.Prisma.UserAccountsScalarFieldEnum = {
  userId: 'userId',
  accountId: 'accountId',
  loginAccountId: 'loginAccountId'
};

exports.Prisma.UserLoginAccountScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  type: 'type',
  provider: 'provider',
  providerAccountId: 'providerAccountId',
  refreshToken: 'refreshToken',
  refreshTokenExpiresIn: 'refreshTokenExpiresIn',
  accessToken: 'accessToken',
  expiresAt: 'expiresAt',
  tokenType: 'tokenType',
  scope: 'scope',
  idToken: 'idToken',
  sessionState: 'sessionState'
};

exports.Prisma.TeamInviteScalarFieldEnum = {
  teamId: 'teamId',
  email: 'email',
  expires: 'expires',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  role: 'role'
};

exports.Prisma.TeamMemberScalarFieldEnum = {
  id: 'id',
  teamId: 'teamId',
  userId: 'userId',
  joinedAt: 'joinedAt',
  role: 'role',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt'
};

exports.Prisma.TeamSettingsScalarFieldEnum = {
  id: 'id',
  teamId: 'teamId',
  settingKey: 'settingKey',
  settingValue: 'settingValue',
  settingStatus: 'settingStatus',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt'
};

exports.Prisma.NotificationPreferenceScalarFieldEnum = {
  id: 'id',
  teamMemberId: 'teamMemberId',
  values: 'values'
};

exports.Prisma.TeamScalarFieldEnum = {
  id: 'id',
  name: 'name',
  subscriptionId: 'subscriptionId',
  slug: 'slug',
  logo: 'logo',
  inviteCode: 'inviteCode',
  plan: 'plan',
  stripeId: 'stripeId',
  billingCycleStart: 'billingCycleStart',
  paymentFailedAt: 'paymentFailedAt',
  stripeConnectId: 'stripeConnectId',
  payoutMethodId: 'payoutMethodId',
  invoicePrefix: 'invoicePrefix',
  totalLinks: 'totalLinks',
  totalJobs: 'totalJobs',
  totalClicks: 'totalClicks',
  usage: 'usage',
  usageLimit: 'usageLimit',
  linksUsage: 'linksUsage',
  linksLimit: 'linksLimit',
  salesUsage: 'salesUsage',
  salesLimit: 'salesLimit',
  domainsLimit: 'domainsLimit',
  tagsLimit: 'tagsLimit',
  usersLimit: 'usersLimit',
  aiUsage: 'aiUsage',
  aiLimit: 'aiLimit',
  jobsUsage: 'jobsUsage',
  jobsLimit: 'jobsLimit',
  foldersUsage: 'foldersUsage',
  foldersLimit: 'foldersLimit',
  candidatesUsage: 'candidatesUsage',
  candidatesLimit: 'candidatesLimit',
  collaboratorsUsage: 'collaboratorsUsage',
  collaboratorsLimit: 'collaboratorsLimit',
  store: 'store',
  allowedHostnames: 'allowedHostnames',
  paymentProvider: 'paymentProvider',
  stripeCustomerId: 'stripeCustomerId',
  chargebeeCustomerId: 'chargebeeCustomerId',
  razorpayCustomerId: 'razorpayCustomerId',
  defaultCurrency: 'defaultCurrency',
  companyName: 'companyName',
  companyUrl: 'companyUrl',
  referralLinkId: 'referralLinkId',
  referredSignups: 'referredSignups',
  webhookEnabled: 'webhookEnabled',
  partnersEnabled: 'partnersEnabled',
  ssoEnabled: 'ssoEnabled',
  conversionEnabled: 'conversionEnabled',
  dotLinkClaimed: 'dotLinkClaimed',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  usageLastChecked: 'usageLastChecked'
};

exports.Prisma.BucketsScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  downloadExpiration: 'downloadExpiration',
  minUploadFileSize: 'minUploadFileSize',
  maxUploadFileSize: 'maxUploadFileSize',
  cacheControl: 'cacheControl',
  presignedUrlsEnabled: 'presignedUrlsEnabled'
};

exports.Prisma.FilesScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  bucketId: 'bucketId',
  name: 'name',
  size: 'size',
  mimeType: 'mimeType',
  etag: 'etag',
  isUploaded: 'isUploaded',
  uploadedByUserId: 'uploadedByUserId',
  metadata: 'metadata'
};

exports.Prisma.VirusScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  fileId: 'fileId',
  filename: 'filename',
  virus: 'virus',
  userSession: 'userSession'
};

exports.Prisma.SortOrder = {
  asc: 'asc',
  desc: 'desc'
};

exports.Prisma.NullableJsonNullValueInput = {
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull
};

exports.Prisma.JsonNullValueInput = {
  JsonNull: Prisma.JsonNull
};

exports.Prisma.QueryMode = {
  default: 'default',
  insensitive: 'insensitive'
};

exports.Prisma.NullsOrder = {
  first: 'first',
  last: 'last'
};

exports.Prisma.CandidateOrderByRelevanceFieldEnum = {
  id: 'id',
  firstName: 'firstName',
  lastName: 'lastName',
  email: 'email',
  phone: 'phone',
  nationality: 'nationality',
  summary: 'summary'
};

exports.Prisma.CandidateJobProspectOrderByRelevanceFieldEnum = {
  id: 'id',
  userId: 'userId',
  candidateId: 'candidateId',
  teamId: 'teamId',
  channel: 'channel'
};

exports.Prisma.CandidateJobOrderByRelevanceFieldEnum = {
  candidateId: 'candidateId',
  jobId: 'jobId',
  candidateStatus: 'candidateStatus'
};

exports.Prisma.CandidateUsersOrderByRelevanceFieldEnum = {
  candidateId: 'candidateId',
  userId: 'userId'
};

exports.Prisma.JsonNullValueFilter = {
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull,
  AnyNull: Prisma.AnyNull
};

exports.Prisma.CandidateFileOrderByRelevanceFieldEnum = {
  id: 'id',
  candidateId: 'candidateId',
  quizId: 'quizId',
  fileType: 'fileType',
  fileUrl: 'fileUrl'
};

exports.Prisma.CandidateProctoringReportOrderByRelevanceFieldEnum = {
  id: 'id',
  candidateId: 'candidateId',
  jobId: 'jobId',
  observation: 'observation',
  evidence: 'evidence'
};

exports.Prisma.CandidateJobScreeningOrderByRelevanceFieldEnum = {
  id: 'id',
  candidateId: 'candidateId',
  jobId: 'jobId',
  detailsId: 'detailsId',
  detailsValue: 'detailsValue'
};

exports.Prisma.CandidateJobApplicationOrderByRelevanceFieldEnum = {
  id: 'id',
  candidateId: 'candidateId',
  jobId: 'jobId',
  settingsId: 'settingsId',
  settingsValue: 'settingsValue'
};

exports.Prisma.CandidateJobScreeningApplicationOrderByRelevanceFieldEnum = {
  id: 'id',
  candidateId: 'candidateId',
  jobId: 'jobId',
  settingsId: 'settingsId',
  settingsValue: 'settingsValue'
};

exports.Prisma.CandidateQuizDetailReportOrderByRelevanceFieldEnum = {
  id: 'id',
  candidateId: 'candidateId',
  jobId: 'jobId',
  quizId: 'quizId'
};

exports.Prisma.CandidateQuizReportOrderByRelevanceFieldEnum = {
  id: 'id',
  candidateId: 'candidateId',
  jobId: 'jobId',
  videoResume: 'videoResume'
};

exports.Prisma.CandidateRatingsReportOrderByRelevanceFieldEnum = {
  id: 'id',
  commentedBy: 'commentedBy',
  candidateId: 'candidateId',
  jobId: 'jobId'
};

exports.Prisma.CandidateSkillReportOrderByRelevanceFieldEnum = {
  id: 'id',
  candidateId: 'candidateId',
  jobId: 'jobId',
  quizId: 'quizId',
  jobSkillId: 'jobSkillId'
};

exports.Prisma.CandidateTaxonomyReportOrderByRelevanceFieldEnum = {
  id: 'id',
  candidateId: 'candidateId',
  jobId: 'jobId',
  quizId: 'quizId',
  taxonomy: 'taxonomy'
};

exports.Prisma.CandidateContactDetailOrderByRelevanceFieldEnum = {
  id: 'id',
  candidateId: 'candidateId',
  addressLine1: 'addressLine1',
  addressLine2: 'addressLine2',
  city: 'city',
  state: 'state',
  postalCode: 'postalCode',
  country: 'country',
  website: 'website',
  linkedinUrl: 'linkedinUrl'
};

exports.Prisma.CandidateEducationOrderByRelevanceFieldEnum = {
  id: 'id',
  candidateId: 'candidateId',
  institution: 'institution',
  degree: 'degree',
  field: 'field',
  description: 'description',
  location: 'location'
};

exports.Prisma.CandidateWorkExperienceOrderByRelevanceFieldEnum = {
  id: 'id',
  candidateId: 'candidateId',
  title: 'title',
  company: 'company',
  description: 'description',
  location: 'location'
};

exports.Prisma.CandidateInternshipOrderByRelevanceFieldEnum = {
  id: 'id',
  candidateId: 'candidateId',
  title: 'title',
  company: 'company',
  description: 'description',
  location: 'location'
};

exports.Prisma.CandidateSocialCauseOrderByRelevanceFieldEnum = {
  id: 'id',
  candidateId: 'candidateId',
  title: 'title',
  organization: 'organization',
  causeArea: 'causeArea',
  description: 'description',
  location: 'location'
};

exports.Prisma.CandidateProjectOrderByRelevanceFieldEnum = {
  id: 'id',
  candidateId: 'candidateId',
  title: 'title',
  description: 'description',
  url: 'url'
};

exports.Prisma.CandidateCertificationOrderByRelevanceFieldEnum = {
  id: 'id',
  candidateId: 'candidateId',
  name: 'name',
  issuingOrg: 'issuingOrg',
  credentialId: 'credentialId',
  credentialUrl: 'credentialUrl'
};

exports.Prisma.CandidateSkillOrderByRelevanceFieldEnum = {
  id: 'id',
  candidateId: 'candidateId',
  name: 'name'
};

exports.Prisma.CandidateCommunicationOrderByRelevanceFieldEnum = {
  id: 'id',
  candidateId: 'candidateId',
  additionalNotes: 'additionalNotes'
};

exports.Prisma.CandidateLanguageOrderByRelevanceFieldEnum = {
  id: 'id',
  candidateId: 'candidateId',
  languageName: 'languageName',
  reading: 'reading',
  writing: 'writing',
  listening: 'listening',
  speaking: 'speaking'
};

exports.Prisma.CandidateNationalIdentifierOrderByRelevanceFieldEnum = {
  id: 'id',
  candidateId: 'candidateId',
  identifierNumber: 'identifierNumber',
  country: 'country',
  description: 'description',
  type: 'type'
};

exports.Prisma.CandidateCandidateReferenceOrderByRelevanceFieldEnum = {
  id: 'id',
  candidateId: 'candidateId',
  name: 'name',
  relationship: 'relationship',
  email: 'email',
  phone: 'phone'
};

exports.Prisma.CandidateOnlineProfileOrderByRelevanceFieldEnum = {
  id: 'id',
  candidateId: 'candidateId',
  profileUrl: 'profileUrl',
  platform: 'platform'
};

exports.Prisma.CandidateProductivityDataOrderByRelevanceFieldEnum = {
  id: 'id',
  candidateId: 'candidateId',
  tool: 'tool'
};

exports.Prisma.DashboardOrderByRelevanceFieldEnum = {
  id: 'id',
  linkId: 'linkId',
  teamId: 'teamId',
  userId: 'userId',
  password: 'password'
};

exports.Prisma.DepartmentOrderByRelevanceFieldEnum = {
  id: 'id',
  userId: 'userId',
  name: 'name',
  teamId: 'teamId'
};

exports.Prisma.EmailOrderByRelevanceFieldEnum = {
  id: 'id',
  jobId: 'jobId',
  teamId: 'teamId',
  from: 'from',
  subject: 'subject',
  to: 'to',
  status: 'status'
};

exports.Prisma.SentEmailOrderByRelevanceFieldEnum = {
  id: 'id',
  type: 'type',
  teamId: 'teamId'
};

exports.Prisma.EmailBlacklistOrderByRelevanceFieldEnum = {
  id: 'id'
};

exports.Prisma.CollaboratorAccessEnumOrderByRelevanceFieldEnum = {
  value: 'value'
};

exports.Prisma.CollaboratorRolesEnumOrderByRelevanceFieldEnum = {
  value: 'value'
};

exports.Prisma.DetailValueTypeEnumOrderByRelevanceFieldEnum = {
  value: 'value'
};

exports.Prisma.EmailStatusEnumOrderByRelevanceFieldEnum = {
  value: 'value'
};

exports.Prisma.JobPriorityEnumOrderByRelevanceFieldEnum = {
  value: 'value'
};

exports.Prisma.JobStatusEnumOrderByRelevanceFieldEnum = {
  value: 'value'
};

exports.Prisma.JobSkillTypeEnumOrderByRelevanceFieldEnum = {
  value: 'value'
};

exports.Prisma.QuestionTypeEnumOrderByRelevanceFieldEnum = {
  value: 'value'
};

exports.Prisma.TemplateTypeEnumOrderByRelevanceFieldEnum = {
  value: 'value'
};

exports.Prisma.CandidateStatusEnumOrderByRelevanceFieldEnum = {
  value: 'value'
};

exports.Prisma.WebhookReceiverEnumOrderByRelevanceFieldEnum = {
  value: 'value'
};

exports.Prisma.FolderTypeEnumOrderByRelevanceFieldEnum = {
  value: 'value'
};

exports.Prisma.FolderAccessLevelEnumOrderByRelevanceFieldEnum = {
  value: 'value'
};

exports.Prisma.FolderUserRoleEnumOrderByRelevanceFieldEnum = {
  value: 'value'
};

exports.Prisma.ProfessionalPlatformEnumOrderByRelevanceFieldEnum = {
  value: 'value'
};

exports.Prisma.ProductivityToolEnumOrderByRelevanceFieldEnum = {
  value: 'value'
};

exports.Prisma.LanguageProficiencyEnumOrderByRelevanceFieldEnum = {
  value: 'value'
};

exports.Prisma.NationalIdentifierEnumOrderByRelevanceFieldEnum = {
  value: 'value'
};

exports.Prisma.QuizStatusEnumOrderByRelevanceFieldEnum = {
  value: 'value'
};

exports.Prisma.TaxonomyTagsEnumOrderByRelevanceFieldEnum = {
  value: 'value'
};

exports.Prisma.FolderOrderByRelevanceFieldEnum = {
  id: 'id',
  name: 'name',
  teamId: 'teamId',
  type: 'type',
  accessLevel: 'accessLevel'
};

exports.Prisma.FolderUserOrderByRelevanceFieldEnum = {
  id: 'id',
  folderId: 'folderId',
  userId: 'userId',
  role: 'role'
};

exports.Prisma.FolderAccessRequestOrderByRelevanceFieldEnum = {
  id: 'id',
  folderId: 'folderId',
  userId: 'userId'
};

exports.Prisma.CandidateGithubAnalysisOrderByRelevanceFieldEnum = {
  id: 'id',
  candidateId: 'candidateId',
  githubUrl: 'githubUrl',
  username: 'username',
  avatarUrl: 'avatarUrl',
  bio: 'bio',
  location: 'location',
  company: 'company',
  blog: 'blog',
  strengthAreas: 'strengthAreas',
  improvementAreas: 'improvementAreas'
};

exports.Prisma.CandidateGithubRepositoryOrderByRelevanceFieldEnum = {
  id: 'id',
  analysisId: 'analysisId',
  name: 'name',
  fullName: 'fullName',
  description: 'description',
  url: 'url',
  language: 'language',
  topics: 'topics'
};

exports.Prisma.IntegrationOrderByRelevanceFieldEnum = {
  id: 'id',
  userId: 'userId',
  name: 'name',
  teamId: 'teamId',
  slug: 'slug',
  description: 'description',
  readme: 'readme',
  developer: 'developer',
  website: 'website',
  logo: 'logo',
  installUrl: 'installUrl',
  guideUrl: 'guideUrl',
  category: 'category'
};

exports.Prisma.InstalledIntegrationOrderByRelevanceFieldEnum = {
  id: 'id',
  userId: 'userId',
  integrationId: 'integrationId',
  teamId: 'teamId'
};

exports.Prisma.JobAdditionalDetailsOrderByRelevanceFieldEnum = {
  id: 'id',
  jobId: 'jobId',
  detailKey: 'detailKey',
  detailValueType: 'detailValueType'
};

exports.Prisma.JobCollaboratorsOrderByRelevanceFieldEnum = {
  id: 'id',
  userId: 'userId',
  jobId: 'jobId',
  role: 'role',
  access: 'access'
};

exports.Prisma.JobSettingsOrderByRelevanceFieldEnum = {
  id: 'id',
  jobId: 'jobId',
  settingsKey: 'settingsKey',
  settingsValue: 'settingsValue'
};

exports.Prisma.JobSkillsOrderByRelevanceFieldEnum = {
  id: 'id',
  jobId: 'jobId',
  skillName: 'skillName',
  skillType: 'skillType'
};

exports.Prisma.JobOrderByRelevanceFieldEnum = {
  id: 'id',
  title: 'title',
  key: 'key',
  url: 'url',
  comments: 'comments',
  description: 'description',
  priority: 'priority',
  descriptionPath: 'descriptionPath',
  userId: 'userId',
  externalId: 'externalId',
  tenantId: 'tenantId',
  departmentId: 'departmentId',
  teamId: 'teamId',
  status: 'status',
  folderId: 'folderId'
};

exports.Prisma.JobLinksOrderByRelevanceFieldEnum = {
  jobId: 'jobId',
  linkId: 'linkId'
};

exports.Prisma.JobWebhookOrderByRelevanceFieldEnum = {
  jobId: 'jobId',
  webhookId: 'webhookId'
};

exports.Prisma.LinkOrderByRelevanceFieldEnum = {
  id: 'id',
  domain: 'domain',
  key: 'key',
  url: 'url',
  shortLink: 'shortLink',
  expiredUrl: 'expiredUrl',
  password: 'password',
  title: 'title',
  description: 'description',
  image: 'image',
  video: 'video',
  utmSource: 'utmSource',
  utmMedium: 'utmMedium',
  utmCampaign: 'utmCampaign',
  utmTerm: 'utmTerm',
  utmContent: 'utmContent',
  ios: 'ios',
  android: 'android',
  userId: 'userId',
  teamId: 'teamId',
  programId: 'programId',
  folderId: 'folderId',
  externalId: 'externalId',
  tenantId: 'tenantId',
  comments: 'comments',
  partnerId: 'partnerId'
};

exports.Prisma.OAuthAppOrderByRelevanceFieldEnum = {
  id: 'id',
  integrationId: 'integrationId',
  clientId: 'clientId',
  hashedClientSecret: 'hashedClientSecret',
  partialClientSecret: 'partialClientSecret'
};

exports.Prisma.OAuthCodeOrderByRelevanceFieldEnum = {
  id: 'id',
  clientId: 'clientId',
  userId: 'userId',
  teamId: 'teamId',
  code: 'code',
  scopes: 'scopes',
  redirectUri: 'redirectUri',
  codeChallenge: 'codeChallenge',
  codeChallengeMethod: 'codeChallengeMethod'
};

exports.Prisma.OAuthRefreshTokenOrderByRelevanceFieldEnum = {
  id: 'id',
  installationId: 'installationId',
  accessTokenId: 'accessTokenId',
  hashedRefreshToken: 'hashedRefreshToken'
};

exports.Prisma.QuizLibraryOrderByRelevanceFieldEnum = {
  id: 'id',
  skillName: 'skillName',
  question: 'question',
  asset: 'asset',
  choiceA: 'choiceA',
  choiceB: 'choiceB',
  choiceC: 'choiceC',
  choiceD: 'choiceD',
  experienceLevel: 'experienceLevel'
};

exports.Prisma.JobQuizLibraryMappingOrderByRelevanceFieldEnum = {
  id: 'id',
  libraryId: 'libraryId',
  jobId: 'jobId'
};

exports.Prisma.QuizLibraryUsageOrderByRelevanceFieldEnum = {
  id: 'id',
  libraryId: 'libraryId'
};

exports.Prisma.CandidateQuizOrderByRelevanceFieldEnum = {
  id: 'id',
  candidateId: 'candidateId',
  quizId: 'quizId',
  status: 'status'
};

exports.Prisma.CandidateQuestionOrderByRelevanceFieldEnum = {
  id: 'id',
  questionId: 'questionId',
  type: 'type'
};

exports.Prisma.QuestionMcqOptionOrderByRelevanceFieldEnum = {
  id: 'id',
  text: 'text',
  questionId: 'questionId'
};

exports.Prisma.QuestionRankOptionOrderByRelevanceFieldEnum = {
  id: 'id',
  text: 'text',
  questionId: 'questionId'
};

exports.Prisma.QuestionMcqAnswerOrderByRelevanceFieldEnum = {
  id: 'id',
  quizId: 'quizId',
  questionId: 'questionId',
  optionId: 'optionId'
};

exports.Prisma.QuestionRankAnswerOrderByRelevanceFieldEnum = {
  id: 'id',
  quizId: 'quizId',
  questionId: 'questionId'
};

exports.Prisma.QuestionRankOptionAnswerOrderByRelevanceFieldEnum = {
  id: 'id',
  answerId: 'answerId',
  optionId: 'optionId'
};

exports.Prisma.TagOrderByRelevanceFieldEnum = {
  id: 'id',
  name: 'name',
  color: 'color',
  teamId: 'teamId'
};

exports.Prisma.JobTagOrderByRelevanceFieldEnum = {
  id: 'id',
  jobId: 'jobId',
  tagId: 'tagId'
};

exports.Prisma.LinkTagOrderByRelevanceFieldEnum = {
  id: 'id',
  linkId: 'linkId',
  tagId: 'tagId'
};

exports.Prisma.ContentTemplatesOrderByRelevanceFieldEnum = {
  template: 'template',
  templateType: 'templateType',
  name: 'name',
  teamId: 'teamId',
  userId: 'userId'
};

exports.Prisma.JobEmailTemplateOrderByRelevanceFieldEnum = {
  id: 'id',
  jobId: 'jobId',
  name: 'name',
  subject: 'subject',
  body: 'body',
  signature: 'signature',
  createdBy: 'createdBy'
};

exports.Prisma.CandidateEmailOutreachOrderByRelevanceFieldEnum = {
  id: 'id',
  emailTemplateId: 'emailTemplateId',
  candidateId: 'candidateId',
  jobId: 'jobId',
  userId: 'userId',
  resendId: 'resendId',
  messageId: 'messageId',
  status: 'status',
  subject: 'subject',
  body: 'body'
};

exports.Prisma.TokenOrderByRelevanceFieldEnum = {
  id: 'id',
  name: 'name',
  hashedKey: 'hashedKey',
  partialKey: 'partialKey',
  userId: 'userId'
};

exports.Prisma.ExtensionTokenOrderByRelevanceFieldEnum = {
  identifier: 'identifier',
  token: 'token',
  userId: 'userId'
};

exports.Prisma.RestrictedTokenOrderByRelevanceFieldEnum = {
  id: 'id',
  name: 'name',
  hashedKey: 'hashedKey',
  partialKey: 'partialKey',
  scopes: 'scopes',
  userId: 'userId',
  teamId: 'teamId',
  installationId: 'installationId'
};

exports.Prisma.VerificationTokenOrderByRelevanceFieldEnum = {
  identifier: 'identifier',
  token: 'token'
};

exports.Prisma.EmailVerificationTokenOrderByRelevanceFieldEnum = {
  identifier: 'identifier',
  token: 'token'
};

exports.Prisma.PasswordResetTokenOrderByRelevanceFieldEnum = {
  identifier: 'identifier',
  token: 'token'
};

exports.Prisma.UtmTemplateOrderByRelevanceFieldEnum = {
  id: 'id',
  name: 'name',
  utmSource: 'utmSource',
  utmMedium: 'utmMedium',
  utmCampaign: 'utmCampaign',
  utmTerm: 'utmTerm',
  utmContent: 'utmContent',
  ref: 'ref',
  userId: 'userId',
  teamId: 'teamId'
};

exports.Prisma.WebhookOrderByRelevanceFieldEnum = {
  id: 'id',
  receiver: 'receiver',
  installationId: 'installationId',
  teamId: 'teamId',
  name: 'name',
  url: 'url',
  secret: 'secret'
};

exports.Prisma.LinkWebhookOrderByRelevanceFieldEnum = {
  linkId: 'linkId',
  webhookId: 'webhookId'
};

exports.Prisma.ProviderRequestsOrderByRelevanceFieldEnum = {
  id: 'id'
};

exports.Prisma.ProvidersOrderByRelevanceFieldEnum = {
  id: 'id'
};

exports.Prisma.RefreshTokenTypesOrderByRelevanceFieldEnum = {
  value: 'value',
  comment: 'comment'
};

exports.Prisma.RefreshTokenOrderByRelevanceFieldEnum = {
  id: 'id',
  userId: 'userId',
  type: 'type',
  refreshTokenHash: 'refreshTokenHash'
};

exports.Prisma.RoleOrderByRelevanceFieldEnum = {
  id: 'id'
};

exports.Prisma.SessionOrderByRelevanceFieldEnum = {
  id: 'id',
  sessionToken: 'sessionToken',
  userId: 'userId'
};

exports.Prisma.UserProvidersOrderByRelevanceFieldEnum = {
  id: 'id',
  userId: 'userId',
  accessToken: 'accessToken',
  refreshTokenKey: 'refreshTokenKey',
  providerId: 'providerId',
  providerUserId: 'providerUserId'
};

exports.Prisma.AuthUserRolesOrderByRelevanceFieldEnum = {
  id: 'id',
  userId: 'userId',
  role: 'role'
};

exports.Prisma.UserSecurityKeysOrderByRelevanceFieldEnum = {
  id: 'id',
  userId: 'userId',
  credentialId: 'credentialId',
  transports: 'transports',
  nickname: 'nickname'
};

exports.Prisma.AccountOrderByRelevanceFieldEnum = {
  id: 'id',
  displayName: 'displayName',
  image: 'image',
  locale: 'locale',
  email: 'email',
  phoneNumber: 'phoneNumber',
  passwordHash: 'passwordHash',
  newEmail: 'newEmail',
  otpMethodLastUsed: 'otpMethodLastUsed',
  otpHash: 'otpHash',
  defaultRole: 'defaultRole',
  totpSecret: 'totpSecret',
  activeMfaType: 'activeMfaType',
  ticket: 'ticket',
  webauthnCurrentChallenge: 'webauthnCurrentChallenge'
};

exports.Prisma.CommissionOrderByRelevanceFieldEnum = {
  id: 'id',
  programId: 'programId',
  partnerId: 'partnerId',
  linkId: 'linkId',
  payoutId: 'payoutId',
  invoiceId: 'invoiceId',
  customerId: 'customerId',
  eventId: 'eventId',
  currency: 'currency',
  status: 'status',
  type: 'type'
};

exports.Prisma.CustomerOrderByRelevanceFieldEnum = {
  id: 'id',
  name: 'name',
  email: 'email',
  avatar: 'avatar',
  externalId: 'externalId',
  stripeCustomerId: 'stripeCustomerId',
  linkId: 'linkId',
  clickId: 'clickId',
  country: 'country',
  teamId: 'teamId',
  teamConnectId: 'teamConnectId'
};

exports.Prisma.DiscountOrderByRelevanceFieldEnum = {
  id: 'id',
  couponId: 'couponId',
  couponTestId: 'couponTestId',
  teamId: 'teamId',
  programId: 'programId',
  type: 'type',
  interval: 'interval'
};

exports.Prisma.DomainOrderByRelevanceFieldEnum = {
  id: 'id',
  slug: 'slug',
  placeholder: 'placeholder',
  expiredUrl: 'expiredUrl',
  notFoundUrl: 'notFoundUrl',
  logo: 'logo',
  teamId: 'teamId'
};

exports.Prisma.RegisteredDomainOrderByRelevanceFieldEnum = {
  id: 'id',
  slug: 'slug',
  teamId: 'teamId',
  domainId: 'domainId'
};

exports.Prisma.DefaultDomainsOrderByRelevanceFieldEnum = {
  id: 'id',
  teamId: 'teamId'
};

exports.Prisma.SubscriptionStatusEnumOrderByRelevanceFieldEnum = {
  value: 'value'
};

exports.Prisma.WorkspacePlansEnumOrderByRelevanceFieldEnum = {
  value: 'value'
};

exports.Prisma.PricingPlanIntervalEnumOrderByRelevanceFieldEnum = {
  value: 'value'
};

exports.Prisma.PricingTypeEnumOrderByRelevanceFieldEnum = {
  value: 'value'
};

exports.Prisma.UserRolesEnumOrderByRelevanceFieldEnum = {
  value: 'value'
};

exports.Prisma.PayoutStatusEnumOrderByRelevanceFieldEnum = {
  value: 'value'
};

exports.Prisma.PayoutTypeEnumOrderByRelevanceFieldEnum = {
  value: 'value'
};

exports.Prisma.ProgramTypeEnumOrderByRelevanceFieldEnum = {
  value: 'value'
};

exports.Prisma.CommissionTypeEnumOrderByRelevanceFieldEnum = {
  value: 'value'
};

exports.Prisma.ProgramEnrollmentStatusEnumOrderByRelevanceFieldEnum = {
  value: 'value'
};

exports.Prisma.CommissionIntervalEnumOrderByRelevanceFieldEnum = {
  value: 'value'
};

exports.Prisma.PartnerStatusEnumOrderByRelevanceFieldEnum = {
  value: 'value'
};

exports.Prisma.PartnerRoleEnumOrderByRelevanceFieldEnum = {
  value: 'value'
};

exports.Prisma.InvoiceStatusEnumOrderByRelevanceFieldEnum = {
  value: 'value'
};

exports.Prisma.CommissionStatusEnumOrderByRelevanceFieldEnum = {
  value: 'value'
};

exports.Prisma.EventTypeEnumOrderByRelevanceFieldEnum = {
  value: 'value'
};

exports.Prisma.PaymentProviderEnumOrderByRelevanceFieldEnum = {
  value: 'value'
};

exports.Prisma.PartnerProfileTypeEnumOrderByRelevanceFieldEnum = {
  value: 'value'
};

exports.Prisma.PayoutInvoiceOrderByRelevanceFieldEnum = {
  id: 'id',
  teamId: 'teamId',
  number: 'number',
  programId: 'programId',
  status: 'status',
  receiptUrl: 'receiptUrl'
};

exports.Prisma.SubscriptionInvoiceOrderByRelevanceFieldEnum = {
  id: 'id',
  teamId: 'teamId',
  number: 'number',
  subscriptionId: 'subscriptionId',
  status: 'status',
  receiptUrl: 'receiptUrl',
  providerType: 'providerType',
  providerInvoiceId: 'providerInvoiceId',
  currency: 'currency'
};

exports.Prisma.JacksonIndexOrderByRelevanceFieldEnum = {
  key: 'key',
  storeKey: 'storeKey'
};

exports.Prisma.JacksonStoreOrderByRelevanceFieldEnum = {
  key: 'key',
  value: 'value',
  iv: 'iv',
  tag: 'tag',
  namespace: 'namespace'
};

exports.Prisma.JacksonTtlOrderByRelevanceFieldEnum = {
  key: 'key'
};

exports.Prisma.PartnerOrderByRelevanceFieldEnum = {
  id: 'id',
  name: 'name',
  companyName: 'companyName',
  profileType: 'profileType',
  email: 'email',
  image: 'image',
  description: 'description',
  country: 'country',
  status: 'status',
  stripeConnectId: 'stripeConnectId',
  website: 'website',
  websiteTxtRecord: 'websiteTxtRecord',
  youtube: 'youtube',
  twitter: 'twitter',
  linkedin: 'linkedin',
  instagram: 'instagram'
};

exports.Prisma.PartnerUserOrderByRelevanceFieldEnum = {
  id: 'id',
  role: 'role',
  userId: 'userId',
  partnerId: 'partnerId'
};

exports.Prisma.PartnerInviteOrderByRelevanceFieldEnum = {
  email: 'email',
  partnerId: 'partnerId',
  role: 'role'
};

exports.Prisma.PayoutOrderByRelevanceFieldEnum = {
  id: 'id',
  programId: 'programId',
  partnerId: 'partnerId',
  invoiceId: 'invoiceId',
  currency: 'currency',
  status: 'status',
  type: 'type',
  description: 'description',
  stripeTransferId: 'stripeTransferId'
};

exports.Prisma.PriceOrderByRelevanceFieldEnum = {
  id: 'id',
  productId: 'productId',
  description: 'description',
  currency: 'currency',
  type: 'type',
  interval: 'interval'
};

exports.Prisma.ProductOrderByRelevanceFieldEnum = {
  id: 'id',
  name: 'name',
  description: 'description',
  image: 'image'
};

exports.Prisma.ProgramOrderByRelevanceFieldEnum = {
  id: 'id',
  teamId: 'teamId',
  name: 'name',
  slug: 'slug',
  logo: 'logo',
  wordmark: 'wordmark',
  brandColor: 'brandColor',
  domain: 'domain',
  url: 'url',
  type: 'type',
  defaultRewardId: 'defaultRewardId',
  defaultFolderId: 'defaultFolderId',
  defaultDiscountId: 'defaultDiscountId',
  termsUrl: 'termsUrl'
};

exports.Prisma.ProgramEnrollmentOrderByRelevanceFieldEnum = {
  id: 'id',
  partnerId: 'partnerId',
  programId: 'programId',
  tenantId: 'tenantId',
  applicationId: 'applicationId',
  discountId: 'discountId',
  status: 'status'
};

exports.Prisma.ProgramApplicationOrderByRelevanceFieldEnum = {
  id: 'id',
  programId: 'programId',
  partnerId: 'partnerId',
  name: 'name',
  email: 'email',
  proposal: 'proposal',
  website: 'website',
  comments: 'comments'
};

exports.Prisma.RewardOrderByRelevanceFieldEnum = {
  id: 'id',
  programId: 'programId',
  name: 'name',
  event: 'event',
  type: 'type'
};

exports.Prisma.PartnerRewardOrderByRelevanceFieldEnum = {
  id: 'id',
  programEnrollmentId: 'programEnrollmentId',
  rewardId: 'rewardId'
};

exports.Prisma.SubscriptionOrderByRelevanceFieldEnum = {
  id: 'id',
  status: 'status',
  priceId: 'priceId',
  providerType: 'providerType',
  providerSubscriptionId: 'providerSubscriptionId'
};

exports.Prisma.UserOrderByRelevanceFieldEnum = {
  id: 'id',
  email: 'email',
  defaultTeam: 'defaultTeam',
  defaultPartnerId: 'defaultPartnerId',
  source: 'source',
  saasPartnerId: 'saasPartnerId',
  passwordHash: 'passwordHash',
  image: 'image',
  name: 'name',
  provider: 'provider'
};

exports.Prisma.UserAccountsOrderByRelevanceFieldEnum = {
  userId: 'userId',
  accountId: 'accountId',
  loginAccountId: 'loginAccountId'
};

exports.Prisma.UserLoginAccountOrderByRelevanceFieldEnum = {
  id: 'id',
  userId: 'userId',
  type: 'type',
  provider: 'provider',
  providerAccountId: 'providerAccountId',
  refreshToken: 'refreshToken',
  accessToken: 'accessToken',
  tokenType: 'tokenType',
  scope: 'scope',
  idToken: 'idToken',
  sessionState: 'sessionState'
};

exports.Prisma.TeamInviteOrderByRelevanceFieldEnum = {
  teamId: 'teamId',
  email: 'email',
  role: 'role'
};

exports.Prisma.TeamMemberOrderByRelevanceFieldEnum = {
  id: 'id',
  teamId: 'teamId',
  userId: 'userId',
  role: 'role'
};

exports.Prisma.TeamSettingsOrderByRelevanceFieldEnum = {
  id: 'id',
  teamId: 'teamId',
  settingKey: 'settingKey',
  settingValue: 'settingValue'
};

exports.Prisma.NotificationPreferenceOrderByRelevanceFieldEnum = {
  id: 'id',
  teamMemberId: 'teamMemberId'
};

exports.Prisma.TeamOrderByRelevanceFieldEnum = {
  id: 'id',
  name: 'name',
  subscriptionId: 'subscriptionId',
  slug: 'slug',
  logo: 'logo',
  inviteCode: 'inviteCode',
  plan: 'plan',
  stripeId: 'stripeId',
  stripeConnectId: 'stripeConnectId',
  payoutMethodId: 'payoutMethodId',
  invoicePrefix: 'invoicePrefix',
  paymentProvider: 'paymentProvider',
  stripeCustomerId: 'stripeCustomerId',
  chargebeeCustomerId: 'chargebeeCustomerId',
  razorpayCustomerId: 'razorpayCustomerId',
  defaultCurrency: 'defaultCurrency',
  companyName: 'companyName',
  companyUrl: 'companyUrl',
  referralLinkId: 'referralLinkId'
};

exports.Prisma.BucketsOrderByRelevanceFieldEnum = {
  id: 'id',
  cacheControl: 'cacheControl'
};

exports.Prisma.FilesOrderByRelevanceFieldEnum = {
  id: 'id',
  bucketId: 'bucketId',
  name: 'name',
  mimeType: 'mimeType',
  etag: 'etag',
  uploadedByUserId: 'uploadedByUserId'
};

exports.Prisma.VirusOrderByRelevanceFieldEnum = {
  id: 'id',
  fileId: 'fileId',
  filename: 'filename',
  virus: 'virus'
};


exports.Prisma.ModelName = {
  Candidate: 'Candidate',
  CandidateJobProspect: 'CandidateJobProspect',
  CandidateJob: 'CandidateJob',
  CandidateUsers: 'CandidateUsers',
  CandidateFile: 'CandidateFile',
  CandidateProctoringReport: 'CandidateProctoringReport',
  CandidateJobScreening: 'CandidateJobScreening',
  CandidateJobApplication: 'CandidateJobApplication',
  CandidateJobScreeningApplication: 'CandidateJobScreeningApplication',
  CandidateQuizDetailReport: 'CandidateQuizDetailReport',
  CandidateQuizReport: 'CandidateQuizReport',
  CandidateRatingsReport: 'CandidateRatingsReport',
  CandidateSkillReport: 'CandidateSkillReport',
  CandidateTaxonomyReport: 'CandidateTaxonomyReport',
  CandidateContactDetail: 'CandidateContactDetail',
  CandidateEducation: 'CandidateEducation',
  CandidateWorkExperience: 'CandidateWorkExperience',
  CandidateInternship: 'CandidateInternship',
  CandidateSocialCause: 'CandidateSocialCause',
  CandidateProject: 'CandidateProject',
  CandidateCertification: 'CandidateCertification',
  CandidateSkill: 'CandidateSkill',
  CandidateCommunication: 'CandidateCommunication',
  CandidateLanguage: 'CandidateLanguage',
  CandidateNationalIdentifier: 'CandidateNationalIdentifier',
  CandidateCandidateReference: 'CandidateCandidateReference',
  CandidateOnlineProfile: 'CandidateOnlineProfile',
  CandidateProductivityData: 'CandidateProductivityData',
  Dashboard: 'Dashboard',
  Department: 'Department',
  Email: 'Email',
  SentEmail: 'SentEmail',
  EmailBlacklist: 'EmailBlacklist',
  CollaboratorAccessEnum: 'CollaboratorAccessEnum',
  CollaboratorRolesEnum: 'CollaboratorRolesEnum',
  DetailValueTypeEnum: 'DetailValueTypeEnum',
  EmailStatusEnum: 'EmailStatusEnum',
  JobPriorityEnum: 'JobPriorityEnum',
  JobStatusEnum: 'JobStatusEnum',
  JobSkillTypeEnum: 'JobSkillTypeEnum',
  QuestionTypeEnum: 'QuestionTypeEnum',
  TemplateTypeEnum: 'TemplateTypeEnum',
  CandidateStatusEnum: 'CandidateStatusEnum',
  WebhookReceiverEnum: 'WebhookReceiverEnum',
  FolderTypeEnum: 'FolderTypeEnum',
  FolderAccessLevelEnum: 'FolderAccessLevelEnum',
  FolderUserRoleEnum: 'FolderUserRoleEnum',
  ProfessionalPlatformEnum: 'ProfessionalPlatformEnum',
  ProductivityToolEnum: 'ProductivityToolEnum',
  LanguageProficiencyEnum: 'LanguageProficiencyEnum',
  NationalIdentifierEnum: 'NationalIdentifierEnum',
  QuizStatusEnum: 'QuizStatusEnum',
  TaxonomyTagsEnum: 'TaxonomyTagsEnum',
  Folder: 'Folder',
  FolderUser: 'FolderUser',
  FolderAccessRequest: 'FolderAccessRequest',
  CandidateGithubAnalysis: 'CandidateGithubAnalysis',
  CandidateGithubRepository: 'CandidateGithubRepository',
  Integration: 'Integration',
  InstalledIntegration: 'InstalledIntegration',
  JobAdditionalDetails: 'JobAdditionalDetails',
  JobCollaborators: 'JobCollaborators',
  JobSettings: 'JobSettings',
  JobSkills: 'JobSkills',
  Job: 'Job',
  JobLinks: 'JobLinks',
  JobWebhook: 'JobWebhook',
  Link: 'Link',
  OAuthApp: 'OAuthApp',
  OAuthCode: 'OAuthCode',
  OAuthRefreshToken: 'OAuthRefreshToken',
  QuizLibrary: 'QuizLibrary',
  JobQuizLibraryMapping: 'JobQuizLibraryMapping',
  QuizLibraryUsage: 'QuizLibraryUsage',
  CandidateQuiz: 'CandidateQuiz',
  CandidateQuestion: 'CandidateQuestion',
  QuestionMcqOption: 'QuestionMcqOption',
  QuestionRankOption: 'QuestionRankOption',
  QuestionMcqAnswer: 'QuestionMcqAnswer',
  QuestionRankAnswer: 'QuestionRankAnswer',
  QuestionRankOptionAnswer: 'QuestionRankOptionAnswer',
  Tag: 'Tag',
  JobTag: 'JobTag',
  LinkTag: 'LinkTag',
  ContentTemplates: 'ContentTemplates',
  JobEmailTemplate: 'JobEmailTemplate',
  CandidateEmailOutreach: 'CandidateEmailOutreach',
  Token: 'Token',
  ExtensionToken: 'ExtensionToken',
  RestrictedToken: 'RestrictedToken',
  VerificationToken: 'VerificationToken',
  EmailVerificationToken: 'EmailVerificationToken',
  PasswordResetToken: 'PasswordResetToken',
  UtmTemplate: 'UtmTemplate',
  Webhook: 'Webhook',
  LinkWebhook: 'LinkWebhook',
  ProviderRequests: 'ProviderRequests',
  Providers: 'Providers',
  RefreshTokenTypes: 'RefreshTokenTypes',
  RefreshToken: 'RefreshToken',
  Role: 'Role',
  Session: 'Session',
  UserProviders: 'UserProviders',
  AuthUserRoles: 'AuthUserRoles',
  UserSecurityKeys: 'UserSecurityKeys',
  Account: 'Account',
  Commission: 'Commission',
  Customer: 'Customer',
  Discount: 'Discount',
  Domain: 'Domain',
  RegisteredDomain: 'RegisteredDomain',
  DefaultDomains: 'DefaultDomains',
  SubscriptionStatusEnum: 'SubscriptionStatusEnum',
  WorkspacePlansEnum: 'WorkspacePlansEnum',
  PricingPlanIntervalEnum: 'PricingPlanIntervalEnum',
  PricingTypeEnum: 'PricingTypeEnum',
  UserRolesEnum: 'UserRolesEnum',
  PayoutStatusEnum: 'PayoutStatusEnum',
  PayoutTypeEnum: 'PayoutTypeEnum',
  ProgramTypeEnum: 'ProgramTypeEnum',
  CommissionTypeEnum: 'CommissionTypeEnum',
  ProgramEnrollmentStatusEnum: 'ProgramEnrollmentStatusEnum',
  CommissionIntervalEnum: 'CommissionIntervalEnum',
  PartnerStatusEnum: 'PartnerStatusEnum',
  PartnerRoleEnum: 'PartnerRoleEnum',
  InvoiceStatusEnum: 'InvoiceStatusEnum',
  CommissionStatusEnum: 'CommissionStatusEnum',
  EventTypeEnum: 'EventTypeEnum',
  PaymentProviderEnum: 'PaymentProviderEnum',
  PartnerProfileTypeEnum: 'PartnerProfileTypeEnum',
  PayoutInvoice: 'PayoutInvoice',
  SubscriptionInvoice: 'SubscriptionInvoice',
  JacksonIndex: 'JacksonIndex',
  JacksonStore: 'JacksonStore',
  JacksonTtl: 'JacksonTtl',
  Partner: 'Partner',
  PartnerUser: 'PartnerUser',
  PartnerInvite: 'PartnerInvite',
  Payout: 'Payout',
  Price: 'Price',
  Product: 'Product',
  Program: 'Program',
  ProgramEnrollment: 'ProgramEnrollment',
  ProgramApplication: 'ProgramApplication',
  Reward: 'Reward',
  PartnerReward: 'PartnerReward',
  Subscription: 'Subscription',
  User: 'User',
  UserAccounts: 'UserAccounts',
  UserLoginAccount: 'UserLoginAccount',
  TeamInvite: 'TeamInvite',
  TeamMember: 'TeamMember',
  TeamSettings: 'TeamSettings',
  NotificationPreference: 'NotificationPreference',
  Team: 'Team',
  Buckets: 'Buckets',
  Files: 'Files',
  Virus: 'Virus'
};

/**
 * This is a stub Prisma Client that will error at runtime if called.
 */
class PrismaClient {
  constructor() {
    return new Proxy(this, {
      get(target, prop) {
        let message
        const runtime = getRuntime()
        if (runtime.isEdge) {
          message = `PrismaClient is not configured to run in ${runtime.prettyName}. In order to run Prisma Client on edge runtime, either:
- Use Prisma Accelerate: https://pris.ly/d/accelerate
- Use Driver Adapters: https://pris.ly/d/driver-adapters
`;
        } else {
          message = 'PrismaClient is unable to run in this browser environment, or has been bundled for the browser (running in `' + runtime.prettyName + '`).'
        }
        
        message += `
If this is unexpected, please open an issue: https://pris.ly/prisma-prisma-bug-report`

        throw new Error(message)
      }
    })
  }
}

exports.PrismaClient = PrismaClient

Object.assign(exports, Prisma)
